import ImageCropperContainer from "../../../Components/BonusUi/ImageCropper/ImageCropperContainer";

const ImageCropper = () => {
  return <ImageCropperContainer />;
};

export default ImageCropper;
